import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/queryClient";
import { getCompanyPreview } from "@/api/endpoints/companyPreview";

export function useGetCompanyPreview(cui: string | undefined) {
  return useQuery({
    queryKey: queryKeys.companyPreview.byCui(cui || ""),
    queryFn: () => getCompanyPreview({ cui: cui! }),
    enabled: !!cui && cui.length >= 2,
  });
}
